import { ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";

// general detail display section
export const Section = ({ title, icon: Icon, children, sectionKey, scrollPositionRef, expandedSections, setExpandedSections }: any) => {
  // section key matches then no expand section locked
  const isLocked = sectionKey === "documents" || sectionKey === "spouse_documents";

  return (
    <div className="section-container">
      <div
        className={`section-header ${isLocked ? "section-locked" : ""}`}
        role="button"
        tabIndex={isLocked ? -1 : 0}
        onClick={() => {
          if (!isLocked) toggleSection(sectionKey, scrollPositionRef, setExpandedSections);
        }}
      >
        <div className="section-header-left">
          <div className="section-icon">
            <Icon />
          </div>
          <h2 className="section-title">{title}</h2>
        </div>

        {!isLocked && <div className="section-chevron">{expandedSections[sectionKey] ? <ChevronUp /> : <ChevronDown />}</div>}
      </div>

      {expandedSections[sectionKey] && <div className="section-content">{children}</div>}
    </div>
  );
};

// toggle expand and close section
export const toggleSection = (section: string, scrollPositionRef: any, setExpandedSections: any) => {
  //  prevent closing documents section
  if (section === "documents" || section === "spouse_documents") return;

  // save current scroll position
  scrollPositionRef.current = window.scrollY;

  setExpandedSections((prev: any) => ({
    ...prev,
    [section]: !prev[section],
  }));
};

// grid info card box
export const InfoCard = ({ label, value, highlight = false, allowCopy = false, action, lastItem = false, labelWidth = "40%", pb }: any) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(String(value || "—"));
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 5000);
  };

  return (
    <div className={`flex align-items-center pb-2 w-full ${pb ? pb : ''} ${!lastItem ? 'border-bottom-1 border-100' : ''} ${highlight ? "text-primary font-bold" : ""}`}>
      <div className="font-normal mr-2" style={{ width: labelWidth, minWidth: "130px", color: "#555", fontSize: "14px" }}>{label}:</div>
      <div className="font-medium flex align-items-center gap-2" style={{ flex: 1, color: "#000", fontSize: "14px" }}>
        <span style={{ color: (typeof value === 'string' && value.trim().toLowerCase() === 'yes') ? 'red' : 'inherit' }}>
          {value || "—"}
        </span>
        {allowCopy && value && value !== "-" && value !== "—" && (
          <i
            className={`pi ${copied ? "pi-check text-green-500" : "pi-copy text-500 hover:text-primary"} cursor-pointer`}
            style={{ fontSize: "0.9rem" }}
            onClick={handleCopy}
            title={copied ? "Copied!" : "Copy"}
          />
        )}
        {action && action}
      </div>
    </div>
  );
};

// status badge component
export const StatusBadge = ({ status, type = "success" }: any) => {
  return <span className={`status-badge status-${type}`}>{status}</span>;
};
